exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon-container[data-v-a9000238]{\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);\n}\n.icon img[data-v-a9000238]{\n    width:auto;\n}\n.icon-md[data-v-a9000238], .icon-lg[data-v-a9000238]{\n    background-color: white;\n}\n", ""]);

// exports
